import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const toggleSidebar = () => setOpen(!open);

  return (
    <>
      {/* NAVBAR */}
      <nav style={{
        backgroundColor: '#6A0DAD',
        color: 'white',
        padding: '1rem 2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex: 1001,
        position: 'relative',
      }}>
        {/* LOGO */}
        <div style={{ fontWeight: 'bold', fontSize: '1.5rem' }}>
          <Link to="/" style={{ color: 'white', textDecoration: 'none' }}>Pluto Loans</Link>
        </div>

        {/* DESKTOP MENU */}
        <div className="desktop-menu" style={{ display: 'flex', gap: '1.5rem' }}>
          <Link to="/" style={pathname === '/' ? activeLink : link}>Home</Link>
          <Link to="/pre-apply" style={pathname === '/pre-apply' ? activeLink : link}>Pre-Apply</Link>
          <Link to="/contact" style={pathname === '/contact' ? activeLink : link}>Contact</Link>
        </div>

        {/* HAMBURGER ICON (MOBILE) */}
        <div className="hamburger" style={{ display: 'none', cursor: 'pointer' }} onClick={toggleSidebar}>
          {open ? <FaTimes size={22} /> : <FaBars size={22} />}
        </div>
      </nav>

      {/* SIDEBAR – OFF CANVAS LEFT */}
     <div
  className="sidebar"
  style={{
    position: 'fixed',
    top: 0,
    left: open ? 0 : '-260px',
    height: '100vh',
    width: '250px',
    backgroundColor: '#6A0DAD',
    padding: open ? '3rem 1.5rem' : '0',
    display: open ? 'flex' : 'none',
    flexDirection: 'column',
    transition: 'left 0.3s ease-in-out',
    zIndex: 1002,
  }}
>

        <Link to="/" onClick={toggleSidebar} style={pathname === '/' ? activeSidebar : sidebarLink}>Home</Link>
        <Link to="/pre-apply" onClick={toggleSidebar} style={pathname === '/pre-apply' ? activeSidebar : sidebarLink}>Pre-Apply</Link>
        <Link to="/contact" onClick={toggleSidebar} style={pathname === '/contact' ? activeSidebar : sidebarLink}>Contact</Link>
      </div>

      {/* OVERLAY */}
      {open && (
        <div
          onClick={toggleSidebar}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            height: '100vh',
            width: '100vw',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
          }}
        />
      )}

      {/* MEDIA QUERIES */}
      <style>{`
        @media (max-width: 768px) {
          .desktop-menu { display: none !important; }
          .hamburger { display: block !important; color: white; }
        }
        @media (min-width: 769px) {
          .sidebar { display: none !important; }
        }
      `}</style>
    </>
  );
};

const link = {
  color: 'white',
  textDecoration: 'none',
  fontWeight: 600,
};

const activeLink = {
  ...link,
  color: '#FFD700',
};

const sidebarLink = {
  color: 'white',
  textDecoration: 'none',
  fontSize: '1.1rem',
  marginBottom: '1.5rem',
  fontWeight: 600,
};

const activeSidebar = {
  ...sidebarLink,
  color: '#FFD700',
};

export default Navbar;
